import {
    MenuItem,
} from '@chakra-ui/react';
import { ServiceShortName } from '@acp/shared';
import { ReportedFindingsMachineContext } from '../machine/context';

export function ResolveByThirdParty({
    disabled,
    reportedFindingId, // Default value for demonstration purposes
}: {
    disabled?: boolean;
    reportedFindingId: number;
}) {
    const machine = ReportedFindingsMachineContext.useActorRef();

    const isMinimumStandards = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.serviceShortName as ServiceShortName
            === ServiceShortName.MinimumStandards
    );

    const textColor = disabled === true ? 'gray.400' : 'charcoal.900';
    return (
        <MenuItem textColor={textColor} isDisabled={disabled} onClick={() => machine.send({ type: 'RESOLVE_VIA_THIRD_PARTY', reportedFindingId })}>
            {isMinimumStandards ? 'Submit for re-assessment' : 'Resolve by third-party'}
        </MenuItem>
    );
}
